import React from 'react';
import { ASSIGNABLE_TEAM_ROLES, memberRoleSelectValue } from './teamRoleUtils';

export default function TeamMemberRoleSelect({ member, disabled, onChange }) {
  if (member.isOwner) {
    return <span className="teams-role-badge">Owner</span>;
  }
  return (
    <select
      className="teams-role-select"
      value={memberRoleSelectValue(member)}
      disabled={disabled}
      onChange={(e) => onChange(member.userId, e.target.value)}
      aria-label={`Role for ${member.name || member.email || 'member'}`}
    >
      {ASSIGNABLE_TEAM_ROLES.map((opt) => (
        <option key={opt.value} value={opt.value}>{opt.label}</option>
      ))}
    </select>
  );
}
